/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityTorrentsOrderBy } from './MonitEntityTorrentsOrderBy';
import {
    MonitEntityTorrentsOrderByFromJSON,
    MonitEntityTorrentsOrderByFromJSONTyped,
    MonitEntityTorrentsOrderByToJSON,
} from './MonitEntityTorrentsOrderBy';

/**
 * 
 * @export
 * @interface MonitGetEntityTorrentsQueries
 */
export interface MonitGetEntityTorrentsQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityTorrentsQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityTorrentsQueries
     */
    page_size?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityTorrentsQueries
     */
    process_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityTorrentsQueries
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityTorrentsQueries
     */
    search?: string;
    /**
     * 
     * @type {MonitEntityTorrentsOrderBy}
     * @memberof MonitGetEntityTorrentsQueries
     */
    order_by?: MonitEntityTorrentsOrderBy;
    /**
     * 
     * @type {boolean}
     * @memberof MonitGetEntityTorrentsQueries
     */
    desc?: boolean;
}

/**
 * Check if a given object implements the MonitGetEntityTorrentsQueries interface.
 */
export function instanceOfMonitGetEntityTorrentsQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityTorrentsQueriesFromJSON(json: any): MonitGetEntityTorrentsQueries {
    return MonitGetEntityTorrentsQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityTorrentsQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityTorrentsQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'order_by': !exists(json, 'order_by') ? undefined : MonitEntityTorrentsOrderByFromJSON(json['order_by']),
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function MonitGetEntityTorrentsQueriesToJSON(value?: MonitGetEntityTorrentsQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'process_id': value.process_id,
        'source_asset': value.source_asset,
        'search': value.search,
        'order_by': MonitEntityTorrentsOrderByToJSON(value.order_by),
        'desc': value.desc,
    };
}

